// extracted by mini-css-extract-plugin
export var externalLink = "_co-0";
export var internalLinkLabel = "_co-1";